export enum TirednessType {
  unknown = 'transparent',
  low = '#7ED321',
  medium = '#F8E71C',
  high = '#F5A623',
  critical = '#D0021B',
}
